import React, { Component } from "react";
import {  Typography } from "@material-ui/core";
import { BLUE_COLOR } from "../constants";
export default class Labelcontrol extends Component {
  render() {
    var primaryColor = "black";
    var secondaryColor = BLUE_COLOR;

    if(this.props.color){
      primaryColor = this.props.color;
      secondaryColor = this.props.color;
    }

    return (
      <Typography
        style={{ padding: 10, color: secondaryColor,fontWeight:'500' }}
      >
        <span style={{ color: primaryColor }}>{this.props.title} </span>
        {this.props.content}
      </Typography>
    );
}}
